import { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  navigatorIsOffline,
  navigatorIsOnline,
} from "#/redux/resource/ApplicationSlice";

/**
 * Custom React hook to listen to the browser's events and update the application state accordingly.
 *
 * This hook should be used at the root level of the application
 * to ensure that the connection state is tracked throughout the app.
 */
export function useWindowEvent() {
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.debug("Adding window event listeners for online/offline status");
    const goOnline = () => dispatch(navigatorIsOnline());
    const goOffline = () => dispatch(navigatorIsOffline());
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [dispatch]);
}
